<template>
  <div>
    <div>
      <div
        class="w-full h-64 bg-gray-900 flex flex-wrap content-center items-center justify-center text-white"
      >
        <icon name="WaldigLogo" size="8rem" :settings="{ strokeWidth: 0.8, circle: true }" />
      </div>
      <div class="flex items-center justify-center" v-if="!logged">
        <div class="mt-8">
          <h2 class="text-center">{{ $t("login.login") }}</h2>
          <login-form />
          <router-link class="text-sm p-4 text-primary-900 hover:text-primary-500" to="/info">
            <icon class="mr-2 -mt-1" name="Info" />Über Stupsi
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const LoginForm = require("@/modules/login/components/LoginForm").default;

export default {
  name: "LoginSite",
  mixins: [],
  data: () => ({}),
  computed: {
    logged: function() {
      let logged = this.$store.getters["auth/logged"];
      return logged;
    }
  },
  watch: {
    logged: function(newValue) {
      if (newValue === true) {
        this.goTo("/");
      }
    }
  },
  methods: {},
  created() {
    this.$store.dispatch("header/update", {
      clear: true
    });

    if (
      this.$store.getters["auth/token"] &&
      this.$store.getters["auth/token"] !== null
    ) {
      this.goTo("/");
      return;
    }
  },
  components: {
    LoginForm
  }
};
</script>
